module.exports = __webpack_public_path__ + "img/LoginCard-right.b78da2f8.png";